import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BookDemoModal from './BookDemoModal'

const CTASection = () => {
  const navigate = useNavigate()
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false)

  const handleStartTrial = () => {
    navigate('/signup')
  }

  const handleBookDemo = () => {
    setIsDemoModalOpen(true)
  }

  return (
    <section id="book-demo" className="section-padding">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-6">
          Know your traffic. Grow your business.
        </h2>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          Get enterprise-level insights without enterprise prices.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-2">
          <button
            onClick={handleStartTrial}
            className="btn-primary"
          >
            30-Day Risk-Free Trial
          </button>
          <button
            onClick={handleBookDemo}
            className="btn-secondary"
          >
            Book a Demo
          </button>
        </div>
        <span className="text-sm text-gray-500">
          Hardware ships after signup. Trial converts to $99/month unless canceled.
        </span>
      </div>

      <BookDemoModal
        isOpen={isDemoModalOpen}
        onClose={() => setIsDemoModalOpen(false)}
      />
    </section>
  )
}

export default CTASection
